<template>

	<div class="left_nav" :key="courseId" v-if="permission && permission.version === '5'">
    	<b-nav v-if="isStudentLogin">
        <template v-if="!isOpenCourse || course.lmsCourseId">
					<b-nav-item
						:to="{ name: 'courseDashboard', params: { uuid: course.uuid } }"
						role="link"
						:aria-label="$=tf('courseSummaryDashboardAria')">
						 {{ $tf('dashboard') }}
					</b-nav-item>
        </template>
        <template v-if="isOpenCourse">
					<b-nav-item
						:to="{ name: 'courseDetail', params: { uuid: course.uuid } }"
						role="link"
						:aria-label="$tf('courseAbout')">
						 {{ $tf('about') }}
					</b-nav-item>
        </template>
        <template v-if="!isOpenCourse">
            <b-nav-item
							v-if="isContinueLearningReady && continueLearningOptions.length >= 1 && continueLearningOptions[0].title !== 'COURSE_FINISHED'"
							:to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: continueLearningType, entityUuid: continueLearningOptions[0].uuid, subTopicUuid: continueLearningOptions[0].ancestor, action: 'clickLearn' } }"
							:aria-label="$tf('learnAria')">
							<span>
								{{ $tf('learn') }}
							</span>
							<span class="icon icon-play2"></span>
						</b-nav-item>
            <b-nav-item
							v-else
							:to="{ name: 'courseLearn', params: { uuid: course.uuid } }"
							:aria-label="$tf('learn')">
							<span>
								{{ $tf('learn') }}
							</span>
							<span class="icon icon-play2"></span>
						</b-nav-item>
            <b-nav-item
							:to="{ name: 'myReport', params: { uuid: course.uuid, entityId: course.uuid } }"
							:aria-label="$tf('myReportsAria')">
								{{ $tf('myReports') }}
						</b-nav-item>
        </template>
        <template v-if="!course.master && sectionChannel">
          <b-nav-item
						:to="{name: 'courseSectionChannel', params: {uuid: course.uuid, entityId: course.uuid, channelType: 'COURSE'}}"
						role="link"
						:aria-label="$tf('channelAria')">
						 {{ $tf('channel') }}
					</b-nav-item>
        </template>
      </b-nav>
      <b-nav v-else-if="isAdvisorViewingReport">
        <b-nav-item
					:to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: course.uuid, isShowLearnosityReport: false, isAdvisorViewingReport: isAdvisorViewingReport } }"
					role="link"
					:aria-label="$tf('reportsAria')">
						{{ $tf('reportsAria') }}
				</b-nav-item>
      </b-nav>
    	<b-nav v-else>
            <b-nav-item
							:to="{ name: 'courseDashboardInstructor', params: { uuid: course.uuid } }"
							role="link"
							:aria-label="$tf('courseSummaryDashboardAria')">
								{{ $tf('dashboard') }}
						</b-nav-item>
            <template v-if="isEdit">
							<b-nav-item
								:to="{ name: (course.master) ? 'courseEdit' : 'courseSectionEdit', params: { uuid: course.uuid } }"
								role="link"
								:aria-label="$tf('courseAbout')">
									{{ $tf('about') }}
							</b-nav-item>
            </template>
            <template v-else>
							<b-nav-item
								:to="{ name: 'courseDetail', params: { uuid: course.uuid } }"
								role="link"
								:aria-label="$tf('courseAbout')">
									{{ $tf('about') }}
							</b-nav-item>
            </template>
            <template v-if="isCurate">
							<b-nav-item
								:to="{ name: 'courseCuration', params: { uuid: course.uuid } }"
								role="link"
								:aria-label="$tf('courseContentAria')">
									{{ $tf('content') }}
							</b-nav-item>
            </template>
            <template v-else>
							<b-nav-item
								:to="{ name: 'courseLearn', params: { uuid: course.uuid } }"
								role="link"
								:aria-label="$tf('courseContentAria')">
									{{ $tf('content') }}
							</b-nav-item>
            </template>
            <template v-if="permission.coursePermission.canViewReport">
							<template v-if="!course.master">
								<b-nav-item
									:to="{ name: 'classReport', params: { uuid: course.uuid, competencyId: course.uuid, isShowLearnosityReport: false } }"
									role="link"
									:aria-label="$tf('reports')"
									v-if="!course.hideScoreForStudent">
										{{ $tf('reports') }}
								</b-nav-item>
							</template>
            </template>
            <template v-if="permission.coursePermission.canViewGrading">
    			<template v-if="!course.master">
    				<b-nav-item
							:to="{ name: 'grading', params: { uuid: course.uuid } }"
							role="link"
							:aria-label="$tf('gradingAria')">
								{{ $tf('grading') }}
						</b-nav-item>
    			</template>
          <template v-if="!course.master">
            <b-nav-item
							:to="{ name: 'releaseLogic', params: { uuid: course.uuid } }"
							role="link"
							:aria-label="$tf('releaseLogicAria')">
								{{ $tf('releaseLogic') }}
						</b-nav-item>
          </template>
			</template>
			<template v-if="permission.institutionPermission.canAdminister">
    			<template>
    				<b-nav-item
							:disabled="isSandboxUser"
							:to="{ name: 'enrollmentPage', params: { uuid: course.uuid } }"
							role="link"
							:aria-label="$tf('adminAria')">
								{{ $tf('admin') }}
						</b-nav-item>
    			</template>
			</template>
      <template v-if="!course.master && sectionChannel">
        <b-nav-item
					:to="{name: 'courseSectionChannel', params: {uuid: course.uuid, entityId: course.uuid, channelType: 'COURSE'}}"
					role="link"
					:aria-label="$tf('channelAria')">
						{{ $tf('channel') }}
				</b-nav-item>
      </template>
			<!--<b-nav-item
				:to="{ name: 'classGrade', params: { uuid: course.uuid } }">
					{{ $tf('grades') }}
			</b-nav-item>-->
		</b-nav>
	</div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'course-nav',
  props: ['courseId', 'isCurate', 'isEdit', 'isAdvisorViewingReport'],
  data: () => {
    return {
      sectionChannel: null,
      isContinueLearningLoaded: false,
      isContinueLearningReady: false,
      continueLearningType: 'LearningContent',
      continueLearningOptions: [],
      sandboxUsers: ['demoinstructor2@nu.com', 'i1@csu.edu', 'i2@csu.edu', 'i1@vc.edu', 'i2@vc.edu', 'randolph.ward@teachforamerica.org', 'cassandra.zimmer@teachforamerica.org', 'caitlin.ormsby@teachforamerica.org', 'bkransberger@nu.edu', 'i1@lsc.edu', 'i1@pima.edu', 'trinaldi@nu.edu', 'jzavala@nu.edu']
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      if (!this.isContinueLearningReady) {
        this.loadCourse()
      }
    })
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadContinueLearning',
      'loadContinueLearningLast',
      'loadPermission',
      'loadCourseSectionChannel'
    ]),

    async loadCourse () {
      this.sectionChannel = await this.loadCourseSectionChannel(this.courseId)
      if (this.isStudentLogin) {
        this.loadContinueLearningLast({uuid: this.courseId, loadDataFromServer: true}).then((response) => {
          if (response) {
            this.isContinueLearningReady = true
            this.continueLearningOptions = response
          }
        })
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'continueLearning': state => state.course.continueLearning,
      'continuLearningLast': state => state.course.continueLearningLast,
      'permission': state => state.user.permission
    }),

    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    },

    isOpenCourse () {
      if (this.course && (this.course.courseType === 'OPEN' || (this.course.courseType && this.course.courseType.includes('EXTERNAL_')))) {
        return true
      }
      return false
    },

    isSandboxUser () {
      var uObj = JSON.parse(localStorage.getItem('userobj'))
      if (uObj) {
        return this.sandboxUsers.includes(uObj.eMail)
      }
      return false
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/app/course/components/CourseNav.vue